/* open space: ambient sound, orb + ding sfx, signup twirl, drag-to-spin.
   Config comes from data attributes on #ow-root:
     data-ding     success sound
     data-endpoint (static page only) optional JSON endpoint for signups */
(() => {
  const root = document.getElementById("ow-root");
  if (!root) return;
  const cfg = root.dataset;
  const form = document.getElementById("waitlist");
  const status = document.getElementById("status") || root.querySelector(".status");
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ------------------------------------------------------------------ sound */
  const store = {
    get() { try { return localStorage.getItem("ow-sound"); } catch { return null; } },
    set(v) { try { localStorage.setItem("ow-sound", v); } catch {} },
  };
  let soundOn = true; // no sound toggle on the page any more
  let ctx, master, ambient, dingBuf;

  function noiseBuffer(seconds, brown) {
    const len = ctx.sampleRate * seconds;
    const buf = ctx.createBuffer(2, len, ctx.sampleRate);
    for (let c = 0; c < 2; c++) {
      const d = buf.getChannelData(c);
      let last = 0;
      for (let i = 0; i < len; i++) {
        const w = Math.random() * 2 - 1;
        if (brown) { last = (last + 0.02 * w) / 1.02; d[i] = last * 3.5; }
        else d[i] = w;
      }
    }
    return buf;
  }

  function lfo(freq, depth, target, offset) {
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.frequency.value = freq;
    g.gain.value = depth;
    o.connect(g).connect(target);
    if (offset != null) target.value = offset;
    o.start();
    return o;
  }

  function initAudio() {
    if (ctx) return;
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    ctx = new AC();
    master = ctx.createGain();
    master.gain.value = soundOn ? 1 : 0;
    master.connect(ctx.destination);

    // ocean: brown noise swelling through a slow low-pass
    const sea = ctx.createBufferSource();
    sea.buffer = noiseBuffer(6, true);
    sea.loop = true;
    const seaLP = ctx.createBiquadFilter();
    seaLP.type = "lowpass";
    seaLP.Q.value = 0.4;
    // night: a lower, cooler, quieter breeze
    const nightAir = document.documentElement.classList.contains("night");
    lfo(nightAir ? 0.07 : 0.09, nightAir ? 240 : 380, seaLP.frequency, nightAir ? 360 : 520);
    const seaGain = ctx.createGain();
    lfo(0.11, 0.18, seaGain.gain, 0.42);
    sea.connect(seaLP).connect(seaGain);

    // breeze: airy hiss drifting in and out
    const air = ctx.createBufferSource();
    air.buffer = noiseBuffer(5, false);
    air.loop = true;
    const airBP = ctx.createBiquadFilter();
    airBP.type = "bandpass";
    airBP.Q.value = 0.6;
    lfo(0.05, 900, airBP.frequency, nightAir ? 1900 : 2600);
    const airGain = ctx.createGain();
    lfo(0.07, 0.012, airGain.gain, 0.018);
    air.connect(airBP).connect(airGain);

    ambient = ctx.createGain();
    ambient.gain.value = 0;
    seaGain.connect(ambient);
    airGain.connect(ambient);
    ambient.connect(master);
    sea.start();
    air.start();
    ambient.gain.setTargetAtTime(0.11, ctx.currentTime, 1.6);

    if (cfg.ding) {
      fetch(cfg.ding)
        .then((r) => r.arrayBuffer())
        .then((b) => ctx.decodeAudioData(b))
        .then((d) => { dingBuf = d; })
        .catch(() => {});
    }
  }

  function setAmbient(level, time = 1.5) {
    if (ambient) ambient.gain.setTargetAtTime(level, ctx.currentTime, time / 3);
  }

  // soft glassy "bloop" for the orb
  function orbSound() {
    if (!ctx || !soundOn) return;
    const t = ctx.currentTime;
    const out = ctx.createGain();
    out.gain.setValueAtTime(0.0001, t);
    out.gain.exponentialRampToValueAtTime(0.2, t + 0.012);
    out.gain.exponentialRampToValueAtTime(0.0001, t + 0.45);
    const lp = ctx.createBiquadFilter();
    lp.type = "lowpass";
    lp.frequency.value = 2400;
    out.connect(lp).connect(master);
    [[440, 760, "sine", 1], [880, 1520, "triangle", 0.18]].forEach(([a, b, type, v]) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = type;
      o.frequency.setValueAtTime(a, t);
      o.frequency.exponentialRampToValueAtTime(b, t + 0.09);
      g.gain.value = v;
      o.connect(g).connect(out);
      o.start(t);
      o.stop(t + 0.5);
    });
  }

  // airy whoosh as the page opens up
  function whoosh(duration) {
    if (!ctx || !soundOn) return;
    const t = ctx.currentTime;
    const src = ctx.createBufferSource();
    src.buffer = noiseBuffer(duration + 0.5, false);
    const bp = ctx.createBiquadFilter();
    bp.type = "bandpass";
    bp.Q.value = 0.9;
    bp.frequency.setValueAtTime(260, t);
    bp.frequency.exponentialRampToValueAtTime(1800, t + duration * 0.8);
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.09, t + duration * 0.55);
    g.gain.exponentialRampToValueAtTime(0.0001, t + duration + 0.4);
    src.connect(bp).connect(g).connect(master);
    src.start(t);
    src.stop(t + duration + 0.5);
  }

  function ding() {
    if (!ctx || !soundOn || !dingBuf) return;
    const s = ctx.createBufferSource();
    const g = ctx.createGain();
    g.gain.value = 0.5;
    s.buffer = dingBuf;
    s.connect(g).connect(master);
    s.start();
  }

  // start sound on the first real interaction (browsers block it before that)
  const wake = () => {
    initAudio();
    if (ctx && ctx.state === "suspended") ctx.resume();
    removeEventListener("pointerdown", wake);
    removeEventListener("keydown", wake);
  };
  addEventListener("pointerdown", wake);
  addEventListener("keydown", wake);

  // toggle button
  const toggle = document.createElement("button");
  toggle.className = "ow-sound";
  toggle.type = "button";
  toggle.innerHTML =
    '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M2.5 6v4h2.5l3.5 3V3L5 6z" fill="currentColor"/>' +
    '<path class="waves" d="M10.8 5.6a3.4 3.4 0 0 1 0 4.8M12.6 3.8a6 6 0 0 1 0 8.4"/>' +
    '<path class="slash" d="M11 6l3.5 4M14.5 6L11 10"/></svg>';
  const paint = () => {
    toggle.setAttribute("aria-pressed", String(soundOn));
    toggle.setAttribute("aria-label", soundOn ? "mute sound" : "turn sound on");
  };
  paint();
  toggle.addEventListener("click", () => {
    soundOn = !soundOn;
    store.set(soundOn ? "on" : "off");
    paint();
    initAudio();
    if (ctx) {
      if (ctx.state === "suspended") ctx.resume();
      master.gain.setTargetAtTime(soundOn ? 1 : 0, ctx.currentTime, 0.15);
    }
  });
  // (sound toggle removed from the page; the day/night toggle takes its spot)

  // day / night toggle (bottom-right): shows a moon by day and a sun at night
  const moodBtn = document.createElement("button");
  moodBtn.className = "ow-sound ow-mood";
  moodBtn.type = "button";
  const MOON = '<svg viewBox="0 0 16 16"><path d="M13.2 10.4A5.6 5.6 0 0 1 5.6 2.8a5.6 5.6 0 1 0 7.6 7.6z" fill="currentColor"/></svg>';
  const SUN = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="8" cy="8" r="2.8" fill="currentColor" stroke="none"/><path d="M8 1.5v1.6M8 12.9v1.6M1.5 8h1.6M12.9 8h1.6M3.4 3.4l1.1 1.1M11.5 11.5l1.1 1.1M3.4 12.6l1.1-1.1M11.5 4.5l1.1-1.1"/></svg>';
  const paintMood = () => {
    const night = document.documentElement.classList.contains("night");
    moodBtn.innerHTML = night ? SUN : MOON;
    moodBtn.setAttribute("aria-label", night ? "switch to day" : "switch to night");
  };
  paintMood();
  new MutationObserver(paintMood).observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
  moodBtn.addEventListener("click", () => {
    if (!window.__owSetMood) return;
    const night = document.documentElement.classList.contains("night");
    window.__owSetMood(night ? "day" : "night");
  });
  document.body.appendChild(moodBtn);

  /* ------------------------------------------------------------ celebrate */
  // On signup the hoodie does one full twirl, then the ding.
  function celebrate() {
    const product = root.querySelector(".product");
    whoosh(1.1);
    setTimeout(ding, reduced ? 0 : 900);
    if (!product || reduced) return;
    if (spinTo && spinTo.celebrate && spinTo.celebrate()) return;
    product.classList.remove("twirl");
    void product.offsetWidth;
    product.classList.add("twirl");
    product.addEventListener("animationend", () => product.classList.remove("twirl"), { once: true });
  }

  /* --------------------------------------------------------------- signup */
  const CHECK =
    '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 8.5l3 3 6-7"/></svg>';

  function showThanks() {
    const msg = root.dataset.thanks || "Thank you. Check your email shortly.";
    const sub = (cfg.afterSignup && cfg.afterSignupSub) || root.dataset.thanksSub || "We'll email you when the 1st batch drops.";
    form.insertAdjacentHTML(
      "afterend",
      `<div class="ow-thanks" role="status"><span class="orb">${CHECK}</span><span>${msg}</span></div>`
    );
    form.style.display = "none";
    status.classList.remove("error");
    status.classList.add("ow-thanks-sub");
    status.textContent = sub;
  }

  async function submitShopify() {
    const res = await fetch(form.action, {
      method: "POST",
      body: new FormData(form),
      credentials: "same-origin",
      headers: { Accept: "text/html" },
    });
    // Shopify sometimes asks for a captcha: hand over to a normal submit.
    if (res.url.includes("/challenge")) { form.submit(); return "handoff"; }
    const html = await res.text();
    if (res.url.includes("customer_posted=true") || html.includes('class="ow-thanks"')) return "ok";
    return "error";
  }

  async function submitStatic(email) {
    if (!cfg.endpoint) return "ok";
    const res = await fetch(cfg.endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ email }),
    });
    return res.ok ? "ok" : "error";
  }

  if (form) {
    const button = form.querySelector("button");
    const input = form.querySelector('input[type="email"]');
    button.addEventListener("pointerdown", () => { initAudio(); orbSound(); });
    button.addEventListener("keydown", (e) => { if (e.key === "Enter" || e.key === " ") orbSound(); });

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        status.className = "status error";
        status.textContent = "Enter a valid email.";
        return;
      }
      button.disabled = true;
      status.textContent = "";
      let result;
      try {
        result = form.getAttribute("action") ? await submitShopify() : await submitStatic(email);
      } catch { result = "error"; }
      if (result === "handoff") return;
      if (result === "ok") {
        celebrate();
        showThanks();
        moveOn();
      } else {
        status.className = "status error";
        status.textContent = "Something went wrong. Try again.";
        button.disabled = false;
      }
    });
  }

  // reserve flow: once they're on the list, take them to the product page
  function moveOn() {
    if (!cfg.afterSignup) return;
    setTimeout(() => { location.href = cfg.afterSignup; }, reduced ? 600 : 1600);
  }

  // Shopify fallback path (captcha / no-JS submit): page reloads already signed up
  if (root.dataset.posted === "true") { setTimeout(celebrate, 400); moveOn(); }

  /* ----------------------------------------------------------- drag to spin */
  // Idle: the transparent "fan" video (HEVC+alpha for Safari, VP9+alpha elsewhere).
  // Drag / signup: a 48-frame 360° turn drawn on a canvas over it.
  const spin = root.querySelector(".product[data-spin]");
  const video = spin && spin.querySelector("video");
  const hint = root.querySelector(".spin-hint");
  let spinTo = null;

  if (spin && video) {
    // Safari / every iOS browser (WebKit): transparent HEVC. Safari often reports "" for
    // canPlayType('hvc1') even though it plays it, so don't gate on that or it falls back
    // to the opaque white MP4. Chrome/Firefox/Edge: VP9 webm with alpha.
    const isWebKitApple = /Apple/.test(navigator.vendor) || /iP(hone|ad|od)/.test(navigator.userAgent);
    const alphaSrc = isWebKitApple ? cfg.heroHevc : cfg.heroWebm;
    if (alphaSrc) {
      if (cfg.heroPoster) video.poster = cfg.heroPoster;
      video.src = alphaSrc;
      spin.classList.add("alpha");
    } else if (cfg.heroMp4) {
      video.src = cfg.heroMp4;
    }
    video.play().catch(() => {});

    const N = Number(cfg.spinFrames || 0);
    const frames = [];
    const canvas = document.createElement("canvas");
    canvas.className = "spin-canvas";
    spin.appendChild(canvas);
    const c2d = canvas.getContext("2d");
    let loaded = 0, current = 0, raf = 0;

    const load = () => {
      if (frames.length || !N) return;
      for (let i = 0; i < N; i++) {
        const img = new Image();
        img.decoding = "async";
        img.onload = () => { loaded++; };
        img.src = `${cfg.spinBase}${String(i).padStart(2, "0")}.webp${cfg.spinQuery || ""}`;
        frames.push(img);
      }
    };
    (window.requestIdleCallback || ((f) => setTimeout(f, 1500)))(load);

    const draw = (f) => {
      const i = ((Math.round(f) % N) + N) % N;
      const img = frames[i];
      if (!img || !img.complete || !img.naturalWidth) return;
      const r = canvas.getBoundingClientRect();
      const dpr = Math.min(devicePixelRatio || 1, 2);
      const w = Math.round(r.width * dpr), h = Math.round(r.height * dpr);
      if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; }
      c2d.clearRect(0, 0, w, h);
      const s = Math.min(w / img.naturalWidth, h / img.naturalHeight);
      const dw = img.naturalWidth * s, dh = img.naturalHeight * s;
      c2d.drawImage(img, (w - dw) / 2, (h - dh) / 2, dw, dh);
      current = f;
    };
    const showSpin = (on) => spin.classList.toggle("spinning", on);

    // ease from the current frame to a target frame, then optionally hand back to the video
    spinTo = (target, ms, done) => {
      cancelAnimationFrame(raf);
      const from = current, t0 = performance.now();
      const ease = (p) => (p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2);
      const step = (now) => {
        const p = Math.min(1, (now - t0) / ms);
        draw(from + (target - from) * ease(p));
        if (p < 1) raf = requestAnimationFrame(step);
        else { current = ((Math.round(target) % N) + N) % N; if (done) done(); }
      };
      raf = requestAnimationFrame(step);
    };
    // hand back to the blowing video at the moment that best matches the spin's front view
    // (5.96s, found by comparing frames), once that frame is ready, then crossfade
    const MATCH_T = 5.958;
    const backToVideo = () => {
      const reveal = () => requestAnimationFrame(() => showSpin(false));
      const swap = () => {
        if (video.requestVideoFrameCallback) video.requestVideoFrameCallback(reveal);
        else setTimeout(reveal, 80);
      };
      const go = () => video.play().then(swap).catch(swap);
      if (video.duration && Math.abs(video.currentTime - MATCH_T) > 0.05) {
        video.addEventListener("seeked", go, { once: true });
        video.currentTime = Math.min(MATCH_T, video.duration - 0.05);
      } else go();
    };
    const settle = () => {
      // turn back to the nearest front view
      const target = Math.round(current / N) * N;
      spinTo(target, 450 + Math.abs(target - current) * 12, backToVideo);
    };

    let dragging = false, startX = 0, startF = 0;
    let pressX = null;
    spin.addEventListener("pointerdown", (e) => {
      pressX = e.clientX;
      spin.dataset.dragged = "";
      load();
      if (loaded < N) return;
      dragging = true;
      cancelAnimationFrame(raf);
      startX = e.clientX;
      startF = spin.classList.contains("spinning") ? current : 0;
      draw(startF);
      showSpin(true);
      video.pause();
      spin.classList.add("dragging");
      try { spin.setPointerCapture(e.pointerId); } catch {}
    });
    spin.addEventListener("pointermove", (e) => {
      if (pressX != null && Math.abs(e.clientX - pressX) > 6) spin.dataset.dragged = "1";
      if (!dragging) return;
      // one full drag across the hoodie = one full turn
      draw(startF - ((e.clientX - startX) / spin.clientWidth) * N);
      if (hint) hint.classList.add("gone");
    });
    const end = () => {
      pressX = null;
      if (!dragging) return;
      dragging = false;
      spin.classList.remove("dragging");
      settle();
    };
    spin.addEventListener("pointerup", end);
    spin.addEventListener("pointercancel", end);

    // signup: one full turn
    spinTo.celebrate = (done) => {
      if (loaded < N) return false;
      cancelAnimationFrame(raf);
      draw(0);
      showSpin(true);
      video.pause();
      spinTo(N, 1500, done || backToVideo);
      return true;
    };
  }


  /* --------------------------------------------------------------- gallery */
  // In explore, once the hoodie lands, it hands over to a swipeable gallery of
  // angles from the 3D turn plus close-ups. cfg.gallery = "url|caption|kind;..."
  const galleryItems = (cfg.gallery || "").split(";").filter(Boolean).map((row) => {
    // l/r: where the visible hoodie starts/ends inside its image (0..1), so gaps can be even
    const [src, caption, kind, l = "0", r = "1"] = row.split("|");
    return { src, caption, kind, l: parseFloat(l), r: parseFloat(r) };
  });
  let gallery = null, galleryTimer = 0;
  if (galleryItems.length) {
    gallery = document.createElement("div");
    gallery.className = "ow-gallery";
    gallery.setAttribute("aria-label", "hoodie angles");
    gallery.innerHTML =
      '<div class="track">' +
      [...galleryItems, ...galleryItems, ...galleryItems].map((g) =>
        `<figure class="${g.kind === "detail" ? "detail" : "angle"}"><img src="${g.src}" alt="open hoodie, ${g.caption}" decoding="async"></figure>`
      ).join("") +
      '</div><div class="dots">' +
      galleryItems.map((g, i) => `<button type="button" aria-label="${g.caption}"${i ? "" : ' aria-current="true"'}></button>`).join("") +
      "</div>";
    document.body.appendChild(gallery);
    galleryItems.forEach((g) => { new Image().src = g.src; });
    const track = gallery.querySelector(".track");
    const dots = [...gallery.querySelectorAll(".dots button")];
    const figs = [...track.children];

    const current = () => {
      const mid = track.scrollLeft + (gallery.cx ?? track.clientWidth / 2);
      let best = 0, bd = Infinity;
      figs.forEach((f, i) => { const d = Math.abs(centreOf(f) - mid); if (d < bd) { bd = d; best = i; } });
      return best;
    };
    // centre of a slide relative to the track's scroll origin
    const centreOf = (f) => f.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft + f.offsetWidth / 2;
    const goTo = (i, smooth = true) => {
      const f = figs[Math.max(0, Math.min(figs.length - 1, i))];
      track.scrollTo({ left: centreOf(f) - (gallery.cx ?? track.clientWidth / 2), behavior: smooth ? "smooth" : "instant" });
    };
    // endless: three copies of the slides; whenever you settle in the first or last
    // copy, jump silently by one copy's width back into the middle one
    const COUNT = galleryItems.length;
    let settleTimer = 0, down = null;
    const recentre = () => {
      if (down) return;
      let c = current();
      if (c < COUNT || c >= COUNT * 2) {
        const setW = centreOf(figs[COUNT]) - centreOf(figs[0]);
        track.style.scrollBehavior = "auto";
        track.scrollLeft += c < COUNT ? setW : -setW;
        track.style.scrollBehavior = "";
        c = current();
      }
      // settle the nearest slide exactly on the landing spot
      const target = centreOf(figs[c]) - (gallery.cx ?? track.clientWidth / 2);
      if (Math.abs(track.scrollLeft - target) > 1) goTo(c);
    };
    track.addEventListener("scroll", () => {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(recentre, 140);
      const c = current() % COUNT;
      dots.forEach((d, i) => d.setAttribute("aria-current", String(i === c)));
    }, { passive: true });
    dots.forEach((d, i) => d.addEventListener("click", () => goTo(COUNT + i)));

    // desktop: drag with the mouse, and vertical wheel scrolls sideways
    track.addEventListener("pointerdown", (e) => {
      if (e.pointerType !== "mouse") return;
      down = { x: e.clientX, left: track.scrollLeft };
      track.classList.add("dragging");
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener("pointermove", (e) => { if (down) track.scrollLeft = down.left - (e.clientX - down.x); });
    const up = () => { if (!down) return; down = null; track.classList.remove("dragging"); goTo(current()); };
    track.addEventListener("pointerup", up);
    track.addEventListener("pointercancel", up);
    track.addEventListener("wheel", (e) => {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { e.preventDefault(); track.scrollLeft += e.deltaY; }
    }, { passive: false });
    addEventListener("keydown", (e) => {
      if (!gallery.classList.contains("on")) return;
      if (e.key === "ArrowRight") goTo(current() + 1);
      if (e.key === "ArrowLeft") goTo(current() - 1);
    });

    // size + position the gallery where the hoodie lands
    gallery.layout = (box) => {
      const { cx, cy, h, mobile } = box;
      const w = h * (834 / 1112);          // full image box, same as the landed hoodie
      const gap = Math.max(22, w * 0.1) + 10;   // the same visible gap between every slide
      const vw = innerWidth;
      const left = mobile ? 0 : Math.max(vw * 0.44, cx - vw * 0.3);
      gallery.style.left = `${left}px`;
      gallery.style.width = `${vw - left}px`;
      gallery.style.top = `${cy - h / 2}px`;
      track.style.gap = `${gap}px`;
      track.style.paddingLeft = `${cx - left}px`;
      track.style.paddingRight = `${vw - cx}px`;
      figs.forEach((f, i) => {
        const g = galleryItems[i % COUNT];
        const detail = g.kind === "detail";
        const iw = detail ? w * 0.78 : w;
        const ih = detail ? w * 0.78 : h;
        const img = f.querySelector("img");
        // each slide is only as wide as the visible hoodie; the image hangs over its edges
        f.style.width = `${(g.r - g.l) * iw}px`;
        f.style.height = `${h}px`;
        f.style.alignItems = "flex-start";
        f.style.justifyContent = "center";
        img.style.width = `${iw}px`;
        img.style.height = `${ih}px`;
        img.style.marginLeft = `${-g.l * iw}px`;
      });
      gallery.cx = cx - left;
    };
    gallery.show = () => {
      goTo(COUNT, false);
      gallery.classList.add("on");
      document.body.classList.add("gallery-on");
    };
    gallery.hide = () => {
      clearTimeout(galleryTimer);
      gallery.classList.remove("on");
      document.body.classList.remove("gallery-on");
    };
  }

  /* --------------------------------------------------------------- explore */
  // Tap the + logo: the hoodie spins, grows and glides right; product info comes in on the left.
  const info = document.querySelector(".ow-info");
  const logo = root.querySelector(".logo");
  const product = root.querySelector(".product");
  if (info && logo && product) {
    let exploring = false;

    const place = () => {
      if (!exploring) { product.style.transform = ""; return; }
      const prev = product.style.transition;
      product.style.transition = "none";
      product.style.transform = "";
      const r = product.getBoundingClientRect();
      product.offsetWidth;
      product.style.transition = prev;
      const vw = innerWidth, vh = innerHeight, mobile = vw <= 700 || vw < vh;
      const cx = mobile ? vw / 2 : vw * 0.64;
      const targetH = mobile ? vh * 0.46 : vh * 0.68;
      let s = targetH / r.height;
      s = Math.min(s, (mobile ? vw * 0.8 : vw * 0.42) / r.width);
      // phones: tuck the hoodie right under the text block (reserve button)
      let cy = vh * 0.47;
      if (mobile) {
        const infoTop = Math.round(Math.max(84, vh * 0.1));
        const infoH = info.scrollHeight;
        cy = infoTop + infoH - 14 + (r.height * s) / 2;
      }
      const dx = cx - (r.left + r.width / 2);
      const dy = cy - (r.top + r.height / 2);
      product.style.transform = `translate(${dx}px, ${dy}px) scale(${s})`;
      if (gallery) gallery.layout({ cx, cy, h: r.height * s, mobile });
      // phones: hoodie spins down into the lower half, text sits up top under the logo
      if (mobile) {
        info.style.top = `${Math.round(Math.max(84, vh * 0.1))}px`;
        info.style.bottom = "auto";
      } else {
        info.style.top = info.style.bottom = "";
      }
    };

    let lastToggle = 0;
    const setExplore = (on) => {
      if (on === exploring) return;
      // one tap can arrive twice on some phones; ignore a flip-back right after a toggle
      const now = performance.now();
      if (now - lastToggle < 600) return;
      lastToggle = now;
      exploring = on;
      document.body.classList.toggle("exploring", on);
      info.setAttribute("aria-hidden", String(!on));
      logo.setAttribute("aria-expanded", String(on));
      initAudio();
      whoosh(1.0);
      if (on) {
        place();
        // spin lands on the front view, then the gallery (first slide = that same frame) takes over
        const handoff = () => { if (exploring && gallery) gallery.show(); };
        const spun = spinTo && spinTo.celebrate && spinTo.celebrate(gallery ? handoff : undefined);
        if (gallery && !spun) { clearTimeout(galleryTimer); galleryTimer = setTimeout(handoff, 1200); }
      } else {
        if (spinTo && spinTo.celebrate) spinTo.celebrate();
        if (gallery) gallery.hide();
        product.style.transform = "";
      }
    };

    logo.setAttribute("role", "button");
    logo.setAttribute("aria-expanded", "false");
    logo.setAttribute("aria-label", "explore the hoodie");
    logo.addEventListener("click", (e) => { e.preventDefault(); setExplore(!exploring); });
    // tapping the hoodie (not dragging it) opens explore too
    product.addEventListener("click", () => {
      if (product.dataset.dragged === "1") return;
      setExplore(!exploring);
    });
    // in explore, tapping empty sky closes it too
    document.addEventListener("click", (e) => {
      if (!exploring) return;
      if (e.target.closest(".ow-info, .product, .logo, .ow-sound, .ow-gallery")) return;
      setExplore(false);
    });
    info.querySelector(".ow-back")?.addEventListener("click", () => setExplore(false));
    info.querySelector(".ow-join")?.addEventListener("click", () => {
      setExplore(false);
      const input = form && form.querySelector('input[type="email"]');
      if (input) setTimeout(() => input.focus({ preventScroll: true }), 700);
    });
    addEventListener("keydown", (e) => { if (e.key === "Escape") setExplore(false); });
    addEventListener("resize", () => { if (exploring) place(); });
  }

  /* ------------------------------------------------------------ ready */
  // Hide the inline loading screen once the hoodie has a frame and fonts are in.
  {
    const vid = root.querySelector(".product video");
    const videoReady = new Promise((res) => {
      if (!vid || vid.readyState >= 2) return res();
      vid.addEventListener("loadeddata", res, { once: true });
      vid.addEventListener("error", res, { once: true });
      setTimeout(res, 2500); // low-power iPhones may not preload video; the poster covers it
    });
    const fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();
    Promise.all([videoReady, fontsReady]).then(() => { if (window.__owReady) window.__owReady(); });
  }
})();
